export abstract class MetricsService {

    abstract capture(eventName: string, payload: unknown): void;
    abstract reset(): void;

}
